<template>
	<div :class="['standard-input', { condensed: theme === 'condensed' }]">
		<slot name="label" :id="id" :label="label" :labelHidden="labelHidden">
			<label
				v-if="label"
				:for="id"
				class="standard-input_label"
				:class="{ 'visually-hidden': labelHidden }"
			>
				{{ label }}
			</label>
		</slot>
		<input
			:id="id"
			v-bind="$attrs"
			v-on="{
				...$listeners,
				input: (e) => $emit('input', e.target.value)
			}"
			:value="value"
			class="input-text"
			:class="[
				customInputClasses,
				{
					'input__text--disabled': isDisabled,
					'input__text--invalid': error
				}
			]"
			:disabled="isDisabled"
			:style="style"
		/>
		<div
			class="validation-container"
			:style="`min-height: ${validationFixedHeight}`"
		>
			<ValidationErrors
				class="standard-input__validation_errors"
				v-show="error"
				:errors="errorMessages"
			/>
		</div>
	</div>
</template>

<script>
import { ValidationErrors } from "./base";
import { input, label, style } from "./mixins";

/**
 *
 * A standard input component.
 *
 * ## Validation
 *
 * There are two ways to handle validation with components from the inputs module, manual or with Vuelidate. We recommend leveraging Vuelidate when possible. The components in the input module are setup to play nicely with Vuelidate and can help avoid some boilerplate. The use of Vuelidate is not required and you can still manually validate component values via the isError & validationErrors props.
 *
 * [Vuelidate Docs](https://vuelidate.js.org/#getting-started)
 *
 */
export default {
	name: "StandardInput",

	mixins: [input, label, style],

	components: {
		ValidationErrors
	}
};
</script>

<style lang="scss" scoped>
.standard-input {
	display: block;
	width: 100%;
	margin: 0px;
}

.input-text {
	width: 100%;
	margin: 0 0 8px 0;

	.condensed & {
		max-height: 48px;
		height: 100%;
		padding: 14px 18px 12px 18px;
		border: 2px solid $color--neutral-8;

		&:focus {
			border-color: $color--neutral-8 !important;
		}
	}
}

.input__text {
	&--disabled {
		border-color: $color--neutral-8;
		color: $color--neutral-8;
		background-image: none;
		background-color: transparent;
		box-shadow: none;
	}

	&--invalid {
		border-color: $color--red-5 !important;
	}
}

.standard-input_label {
	display: inline-block;
	font-weight: bold;
	line-height: 1;
	margin: 0 0 8px 0;
}

.standard-input__validation_errors {
	margin: 8px 0 0 0;
}

.vg-is-tabbing .input-text:focus {
	outline-offset: 4px;
}
</style>
